<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';

export default {
  name: 'DsfaForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  props: {
    procedureDirectory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <!-- eslint-disable -->
        <v-flex xs12 md6 py-0>
          <v-checkbox
            v-model="procedureDirectory.isImpactAnalysisRequired"
            label="Erforderlichkeit einer Datenschutz-Folgeabschätzung"
            class="caption"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-radio-group v-model="procedureDirectory.auditCause" column label="Grund für eine DSFA">
            <v-radio label="Blacklist Datenschutzaufsichtsbehörden müssen eine sog. Blacklist veröffentlichen. Diese enthält Datenverarbeitungen, die aus Sicht der Datenschutzaufsicht generell ein hohes Risiko haben und daher stets (ohne weitere sonstige Prüfung) vor deren Einsatz eine Vorabkonsultation der Aufsicht erfordern." :value="0"/>
            <v-radio label="Ergebnis der Risikobewertung: (sehr) hohes Risiko und eine Risikoreduzierung ist nicht möglich" :value="1"/>
          </v-radio-group>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.plannedProcessDesc"
            label="Systematische Beschreibung der geplanten Verarbeitungsvorgänge und der Zwecke der Verarbeitung"
            class="caption"
          />
        </v-flex>
        <!-- eslint-enable -->

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.appliedTechnology"
            label="die Eingesetzte Technik"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.gatheredDataType"
            label="die Art der erhobenen Daten"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.gatheredDataScope"
            label="der Umfang der erhobenen Daten"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.dataCollectionCase"
            label="die Umstände der Datenerfassung und Verarbeitung"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.dataCollectionPurpose"
            label="die Zwecke der Datenerfassung und Verarbeitung"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.thoseAffected"
            label="die Betroffenen"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.thoseResponsible"
            label="die Verantwortlichen"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-checkbox
            v-model="procedureDirectory.isProcessingRequired"
            label="Ist die Verarbeitung im Hinblick auf den Zweck notwendig?"
            class="caption"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-checkbox
            v-model="procedureDirectory.isProcessingAppropriate"
            label="Ist die Verarbeitung im Hinblick auf den Zweck angemessen?"
            class="caption"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.respInterestStatement"
            label="die Darlegung des berechtigten Interesses der Verantwortlichen"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.riskEvaluation"
            label="Bewertung der Risiken für die Rechte und Freiheiten der betroffenen Personen"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.riskCorrectiveActions"
            label="Die zur Bewältigung der Risiken geplanten Abhilfemaßnahmen"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-checkbox
            v-model="procedureDirectory.isDsfaClosed"
            label="Abgeschlossen"
            class="caption"
            hide-details
          />
        </v-flex>

      </v-layout>
    </v-container>
  </v-form>
</template>
